import React from 'react';
import { IndustryCaseStudy } from '../../data/industryData';
import '../../styles/CaseStudies.css';

interface CaseStudiesProps {
  caseStudies: IndustryCaseStudy[];
}

const CaseStudies: React.FC<CaseStudiesProps> = ({ caseStudies }) => {
  return (
    <div className="case-studies-section">
      <div className="case-studies-container">
        <h2 className="case-studies-title">Customer Success Stories</h2>
        <p className="case-studies-subtitle">
          See how we've helped organizations overcome complex challenges and achieve measurable results
        </p>
        
        <div className="case-studies-grid">
          {caseStudies.map((caseStudy, index) => (
            <div className="value-card case-study-card-f" key={index}>
              <span className="industry-card-number-idc">{String(index + 1).padStart(2, '0')}</span>
              <h2 className="value-title">{caseStudy.title}</h2>
              <div className='case-study-content'>
                <div className="ml-outcome-content ">
                  <div className="ml-outcome-row">
                    <h4 className='ml-outcome-content-title'>Challenge:</h4>
                    <p className="value-description">{caseStudy.challenge}</p>
                  </div>
                  
                  <div className="ml-outcome-row">
                    <h4 className='ml-outcome-content-title'>Solution:</h4>
                    <p className="value-description">{caseStudy.solution}</p>
                  </div>
                  
                  <div className="ml-outcome-row">
                    <h4 className='ml-outcome-content-title'>Impact:</h4>
                  <p className="value-description">{caseStudy.impact}</p>
                  </div>
                </div>
                
                {caseStudy.metrics && (
                  <div className="case-study-metrics">
                    {caseStudy.metrics.map((metric, idx) => (
                      <div className="case-study-metric" key={idx}>
                        <div className="metric-value">{metric.value}</div>
                        <div className="metric-label">{metric.label}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudies; 